export default __webpack_public_path__ + "static/media/foodNew.c674af22.jpg";